import isApiError from "@insite/client-framework/Common/isApiError";
import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface FreightcalculatorApiParameter extends ApiParameter {
    Customer?: string;
    OrderTotal?: string;
    Products?: any;
    CarriersAndCosts?: string;
    SourceAddress?: any;
    DestinationAddress?: any;
    ShipMethod?: string;
    SPCallDuration?: number;
    TCallDuration?: number;
    OverallDuration?: number;
    onError: (error: string) => void;
}
export interface FreightcalculatorResultModel {
    Customer?: string;
    OrderTotal?: string;
    Products?: Product[];
    SourceAddress?: SourceAddress;
    DestinationAddress?: DestinationAddress;
    ShipMethod?: string;
    carriersAndCosts?: CarriersAndCost[];
}
export interface CarriersAndCost {
    carrierName: string;
    freightCost: number;
    freightCostDisplay:string;
}
export interface Product {
    ItemCode?: string;
    Quantity?: number;
    ShippableQuantity?: number;
}

export interface SourceAddress {
    Line1?: string;
    Line2?: string;
    City?: string;
    State?: string;
    Zip?: string;
    Country?: string;
    ResidentialFlag?: boolean;
    DockDoorRequired?: number;
}

export interface DestinationAddress {
    Line1?: string;
    Line2?: string;
    City?: string;
    State?: string;
    Zip?: string;
    Country?: string;
    ResidentialFlag?: boolean;
    DockDoorRequired?: number;
}

export interface FreightOptionsApiParameter extends ApiParameter {
    uri?: string;
    products: Product[];
    options?: Option[];
    shippingOptions?: string;
    properties?: Properties;
    onError: (error: string) => void;
}
export interface FreightOptionsResultModel {
    uri?: string;
    products: Product[];
    options?: Option[];
    shippingOptions?: string;
    properties?: Properties;
}
export interface Option {
    id: number;
    name: string;
}

export interface Properties {}

const autocompleteUrl = "/api/v2/freight/GetFreightQuote";

const freightOptions = "/api/v2/freight/GetFreightOptions";

export async function freightcalculator(
    parameter: FreightcalculatorApiParameter &
        HasOnSuccess<FreightcalculatorResultModel> &
        HasOnComplete<FreightcalculatorResultModel>,
): Promise<ServiceResult<FreightcalculatorResultModel>> {
    const apiParameter = { ...parameter };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;
    try {
        const result = await post<FreightcalculatorResultModel>(autocompleteUrl, apiParameter);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getFreightOptions(
    parameter: FreightOptionsApiParameter &
        HasOnSuccess<FreightOptionsResultModel> &
        HasOnComplete<FreightOptionsResultModel>,
): Promise<ServiceResult<FreightOptionsResultModel>> {
    const freightOptionsParameter = { ...parameter };
    delete freightOptionsParameter.onSuccess;

    try {
        const result = await post<FreightOptionsResultModel>(freightOptions, freightOptionsParameter);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
